module.exports = __webpack_public_path__ + "img/masetro.3e848f51.png";